import { parseEntity } from '@/shared/converters/commonConverters';
import Counters from '../models/MeasurementCounters';
import TiresSummary from '../models/TiresSummary';

const SUMMARY_SCHEMA = {
  newTires: 'newTiresCount',
  hasTiresSwapped: 'hasTiresSwapped',
  tireMeasurements: (data: any) => parseMeasurementCounters(data.tireMeasurements),
  brakeMeasurements: (data: any) => parseMeasurementCounters(data.brakeMeasurements),
  isMissingSettings: 'isMissingSettings',
};

const COUNTER_SCHEMA = {
  bad: 'badCount',
  caution: 'cautionCount',
  good: 'goodCount',
};

export function parseMeasurementCounters(data: any): Counters | null {
  return parseEntity(data, COUNTER_SCHEMA, Counters);
}

export function parseTiresSummary(data: any): TiresSummary | null {
  return parseEntity(data, SUMMARY_SCHEMA, TiresSummary);
}
